import { fetchPendingBrandPlanSchedules } from 'hooks/queries/schedules/usePendingBrandPlanSchedules'
import { useCallback } from 'react'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { useQueryClient } from 'react-query'
import { calendarKeys } from '../calendar/calendarKeys'
import { scheduleKeys } from './scheduleKeys'

interface Props {
  attempts?: number
  intervalMs?: number
}

export const usePollUntilPendingBrandPlanSchedules = ({ attempts = 10, intervalMs = 1000 }: Props) => {
  const workspaceId = useCurrentWorkspaceId()
  const queryClient = useQueryClient()

  const pollUntilPendingSchedules = useCallback(async () => {
    let attemptCount = 0

    do {
      attemptCount++
      const schedules = await fetchPendingBrandPlanSchedules({ workspaceId })

      if ((schedules && schedules.length > 0) || attemptCount >= attempts) {
        queryClient.setQueryData(scheduleKeys.pending(workspaceId), schedules)
        queryClient.invalidateQueries(calendarKeys.all)
        queryClient.invalidateQueries(scheduleKeys.details())
        break
      }

      await new Promise((resolve) => setTimeout(resolve, intervalMs))
    } while (true)
  }, [workspaceId, attempts, intervalMs, queryClient])

  return pollUntilPendingSchedules
}
